import { EVENT, MOBILE_BREAKPOINT, boundsTW, countryCode } from "../data/constants";
import DATA from "../data/data";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import { SearchParameters } from "../stores-js/searchparameters";
import templates from "../templates";
import {
    EventManager,
    anchorXY,
    corsIconUrl,
    generateMarkersStyleRules,
    generateSearchQuery,
    getPaddingForWindow,
} from "../utils/global";

function toggle(el) {
    if (el.style.display === "none") {
        el.style.display = "";
    } else {
        el.style.display = "none";
    }
}

export default class MapView extends woosmap.map.MVCObject {
    constructor(country, storeId, mapSearchQuery, mainView) {
        super();

        this.map = null;

        this.mainView = mainView;

        this.locationMarker = new woosmap.map.Marker({
            icon: {
                url: `${SETTINGS.serverUrl}css/images/map-icons/position-target.svg`,
                scaledSize: new google.maps.Size(28, 28),
                anchor: new google.maps.Point(14, 14),
            },
        });

        this.destinationMarker = new woosmap.map.Marker({
            icon: {
                url: `${SETTINGS.serverUrl}css/images/map-icons/destination-pin.svg`,
                scaledSize: new google.maps.Size(50, 50),
                anchor: new google.maps.Point(25, 50),
            },
        });

        this.selector = "#storemap-map-canvas";
        this.streetViewCanvasSelector = "#storemap-streetview-canvas";
        // this.searchQuery = new woosmap.search.SearchQuery();
        this.searchParameters = new SearchParameters();
        this.initialBounds = null;
        this.selectedStore = null;

        this.searchBounds = null;
        this.nearbyStores = null;

        this.data = new woosmap.map.Data();
        this.data.setMap(this.map);

        this._initializeMap(country, mapSearchQuery, storeId);

        this._wireEvents();
    }

    _toggleDirectionView() {
        document.querySelector("#storemap-map-directionbutton > div").classList.toggle("storemap-map-button-selected");
        this.mainView.toggleDirectionView();
    }

    _initializeMap(country, mapSearchQuery, storeId) {
        const mapOptions = {
            center: google.maps.LatLng(0, 0),
            zoom: 1,
            disableDefaultUI: true,
            styles: SETTINGS.mapStyles,
            gestureHandling: SETTINGS.enableScrollWheel ? "auto" : "none",
            enableMarkerAccessibleNavigation: true,
        };
        const mapDiv = document.querySelector(this.selector);
        this.map = new google.maps.Map(mapDiv, mapOptions);

        const styleRules = generateMarkersStyleRules();

        if (!storeId) {
            this.storeOverlay = new woosmap.map.StoresOverlay(styleRules);

            woosmap.map.event.addListener(this.storeOverlay, "store_selected", (store) => {
                if (document.querySelector(".wm-poi-detail--footer button")) {
                    document.querySelector(".wm-poi-detail--footer button").textContent =
                        total.maps.L10n.ui.common.close;
                    document.querySelector(".wm-poi-detail--footer button").innerHTML =
                        `<i data-icon="close" data-size="18"></i><span>${total.maps.L10n.ui.common.close}</span>`;
                }
                window.reinitIcons();

                this.mainView.setStoreSelectedFromMap(true);
                this.set("selectedStore", store);
            });

            this.storeOverlay.setMap(this.map);

            if (country && !mapSearchQuery) {
                if (country.toUpperCase() === "TW") {
                    const bounds = new google.maps.LatLngBounds(
                        new google.maps.LatLng(boundsTW.south, boundsTW.west),
                        new google.maps.LatLng(boundsTW.north, boundsTW.east),
                    );
                    google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
                        this.map.setZoom(7);
                    });
                    this.map.fitBounds(bounds, getPaddingForWindow());
                } else {
                    const wantedCountry = countryCode[country.toUpperCase()];
                    DATA.getBoundsForCountry(wantedCountry, (viewport) => {
                        this.initialBounds = {
                            east: viewport.northeast.lng,
                            south: viewport.southwest.lat,
                            north: viewport.northeast.lat,
                            west: viewport.southwest.lng,
                        };
                        this.map.fitBounds(this.initialBounds);
                    });
                }
            } else {
                // Etendue mondiale
                const bounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(-90, -180),
                    new google.maps.LatLng(90, 180),
                );
                this.initialBounds = bounds;
                this.map.fitBounds(bounds, getPaddingForWindow());
            }
            this.map.addListener(this.map, "store_selected", (store) => {
                this.selectedStore = store;
                this.mainView.setStoreSelectedFromMap(true);
                this.selectedStore_changed();
            });
        }
    }

    _wireEvents() {
        document.querySelector("#storemap-map-plusbutton").addEventListener("click", () => {
            this._zoomIn();
        });
        document.querySelector("#storemap-map-minusbutton").addEventListener("click", () => {
            this._zoomOut();
        });

        document.querySelector("#storemap-map-directionbutton").addEventListener("click", () => {
            this._toggleDirectionView();
        });
        this.map.addListener(this.map, "center_changed", (event) => {
            this._handleMapCenterChanged(event);
        });
    }

    onCenterChange(callback) {
        if (this.centerChangeCallback) throw new Error("bounds change callback already registered");
        this.centerChangeCallback = callback;
    }

    _handleMapCenterChanged() {
        this.centerChangeCallback();
    }

    _zoomIn() {
        this.map.setZoom(this.map.getZoom() + 1);
    }

    _zoomOut() {
        this.map.setZoom(this.map.getZoom() - 1);
    }

    _panToStore(store) {
        this.map.panTo({
            lat: store.geometry.coordinates[1],
            lng: store.geometry.coordinates[0],
        });
    }

    zoomToStore(store, offset = 0.005) {
        const lng = store.geometry.coordinates[0];
        const lat = store.geometry.coordinates[1];
        const bounds = new woosmap.map.LatLngBounds();
        bounds.extend(new woosmap.map.LatLng(lat - offset, lng - offset));
        bounds.extend(new woosmap.map.LatLng(lat + offset, lng + offset));
        this.map.fitBounds(bounds, getPaddingForWindow());
    }

    static render() {
        return templates.desktop.map.render(total.maps.L10n.ui);
    }

    selectedStore_changed() {
        const store = this.get("selectedStore");
        // const store = this.selectedStore;
        if (store?.properties?.store_id) {
            SERVICE_REGISTRY.storeService.setSelectedStore(store);
            EventManager.notify(EVENT.STORE_CLICKED, store.properties.store_id);
        }
    }

    // Events

    onQueryFilterChange(tags, types) {
        try {
            this.searchParameters.query = generateSearchQuery().toString();
            this.storeOverlay.setQuery(this.searchParameters.query.toString());
        } catch (error) {
            console.warn(error);
        }
    }

    onLocationChange(location) {
        this.locationMarker.setIcon(this._iconForSource(location.source));
        this.locationMarker.setPosition(location);
        this.locationMarker.setMap(this.map);
    }

    _iconForSource(source) {
        if (source === "gps") {
            return {
                url: `${SETTINGS.serverUrl}css/images/map-icons/position-target.svg`,
                scaledSize: new woosmap.map.Size(30, 30),
                anchor: new woosmap.map.Point(15, 15),
            };
        }
        if (source === "itinerary-origin") {
            return {
                url: `${SETTINGS.serverUrl}css/images/map-icons/position.png`,
                scaledSize: new woosmap.map.Size(28, 28),
                anchor: new woosmap.map.Point(14, 14),
            };
        }
        return {
            url: `${SETTINGS.serverUrl}css/images/map-icons/destination-pin.svg`,
            scaledSize: new woosmap.map.Size(50, 50),
            anchor: new woosmap.map.Point(25, 50),
        };
    }

    showDestinationMarker(location) {
        this.destinationMarker.setPosition(location);
        this.destinationMarker.setMap(this.map);
    }

    hideDestinationMarker() {
        this.destinationMarker.setMap(null);
    }

    onLocationReset() {
        this.locationMarker.setMap(null);
    }

    onSelectedStoreChanged(store, centerOnStore) {
        if (this.storeOverlay.getMap()) {
            this.storeOverlay.setSelection(store);
        }
        if (centerOnStore) {
            this._panToStore(store);
        }
        for (const feature of Object.values(this.data._features)) {
            feature.removeProperty("highlighted");
        }
        const featureToHighlight = this.data.getFeatureById(store.properties.store_id);
        if (featureToHighlight) {
            featureToHighlight.setProperty("highlighted", true);
        }
    }

    onSelectedStoreReset() {
        this.storeOverlay.clearSelection();
        for (const feature of Object.values(this.data._features)) {
            feature.removeProperty("highlighted");
        }
    }
    onResetHighlightedStoreOnRoute() {
        for (const feature of Object.values(this.data._features)) {
            feature.removeProperty("highlighted");
        }
    }

    // #5393 evolution: the whole stores set is displayed
    onNearbyStoresChange(stores) {
        this.nearbyStores = stores;
        const userLocation = SERVICE_REGISTRY.locationService.getLocation();
        const viewport = new google.maps.LatLngBounds();
        // On mobile the static mobilePaddingBounds.top is a worst-case (all
        // top strips visible); measuring .wm-panel--header gives the actual
        // height so the user lands at the true visible-area center.
        const padding = { ...getPaddingForWindow() };
        if (window.innerWidth < MOBILE_BREAKPOINT) {
            const headerEl = document.querySelector(".wm-panel--header");
            if (headerEl && headerEl.offsetHeight > 0) {
                padding.top = headerEl.offsetHeight;
            }
        }

        /* TO DO : OBSERVE THE IMPACT
        if (this.searchBounds) {
            viewport = new google.maps.LatLngBounds(
                {
                    lat: this.searchBounds.south,
                    lng: this.searchBounds.west,
                },
                {
                    lat: this.searchBounds.north,
                    lng: this.searchBounds.east,
                },
            );
        }
        */
        let hasValidStore = false;
        [...stores]
            .sort((a, b) => a.properties.distance - b.properties.distance)
            .forEach((store, index) => {
                if (index < 5 && store.properties.distance < 15000) {
                    const storeLat = store.geometry.coordinates[1];
                    const storeLng = store.geometry.coordinates[0];
                    viewport.extend({ lat: storeLat, lng: storeLng });
                    // Mirror the POI around the user so the bounds stays symmetric
                    // around the user — fitBounds + side-panel padding then keeps
                    // the user at the center of the visible area (issue #175).
                    if (userLocation) {
                        viewport.extend({
                            lat: 2 * userLocation.lat - storeLat,
                            lng: 2 * userLocation.lng - storeLng,
                        });
                    }
                    hasValidStore = true;
                }
            });
        if (hasValidStore) {
            this.map.fitBounds(viewport, padding);
        } else if (userLocation) {
            // No nearby POIs — build a symmetric ~5km box around the user and
            // use fitBounds (not panTo) so the side-panel padding still centers
            // the user in the visible area.
            const defaultDelta = 0.05;
            viewport.extend({ lat: userLocation.lat + defaultDelta, lng: userLocation.lng + defaultDelta });
            viewport.extend({ lat: userLocation.lat - defaultDelta, lng: userLocation.lng - defaultDelta });
            this.map.fitBounds(viewport, padding);
        }
    }

    setSearchBounds(searchBounds) {
        this.searchBounds = searchBounds;
    }

    onItinaryStoresChange(stores) {
        this.showStoresOnRoute(stores);
        if (stores && stores.length > 0) {
            const bounds = this.calculateLatLngBounds(stores);
            this.map.fitBounds(bounds, getPaddingForWindow());
        }
    }
    showStoresOnRoute(stores) {
        for (const feature of Object.values(this.data._features)) {
            this.data.remove(feature);
        }
        for (const store of stores) {
            this.data.add({
                geometry: new woosmap.map.Data.Point({
                    lat: store.geometry.coordinates[1],
                    lng: store.geometry.coordinates[0],
                }),
                id: store.properties.store_id,
                properties: store.properties,
            });
        }
        this.data.setStyle((feature) => {
            let icon = {
                url: `${SETTINGS.serverUrl}css/images/map-icons/black-dot.svg`,
            };
            const brand = feature.properties.user_properties.brand;
            const poiType = feature.properties.user_properties.poiType;
            if (this.map.getZoom() > SETTINGS.rendererBreakScale && !feature.getProperty("highlighted")) {
                icon = {
                    url: corsIconUrl(
                        SETTINGS.iconUrls.brand[brand]?.marker?.[poiType.toLowerCase()] ??
                            SETTINGS.defaultBrandMarkerIcon,
                    ),
                    anchor: new woosmap.map.Point(...anchorXY(poiType, 40)),
                    scaledSize: new woosmap.map.Size(40, 40),
                };
            }
            if (feature.getProperty("highlighted")) {
                icon = {
                    url: corsIconUrl(
                        SETTINGS.iconUrls.brand[brand]?.selectedMarker?.[poiType.toLowerCase()] ??
                            SETTINGS.defaultSelectBrandMarkerIcon,
                    ),
                    anchor: new woosmap.map.Point(...anchorXY(poiType, 60)),
                    scaledSize: new woosmap.map.Size(60, 60),
                };
            }
            return {
                icon,
            };
        });
        this.data.setMap(this.map);
        this.storeOverlay.setMap(null);
        this.selectFeature();
    }
    selectFeature() {
        let highlightedFeatureId;
        this.data.addListener("click", (event) => {
            if (highlightedFeatureId) {
                const highlightedFeature = this.data.getFeatureById(highlightedFeatureId);

                if (highlightedFeature) {
                    highlightedFeature.setProperty("highlighted", false);
                }
            }
            event.feature.setProperty("highlighted", true);
            highlightedFeatureId = event.feature.id;
            event.feature.toGeoJson((geojson) => {
                this.onStoreSelectedOnRoute(geojson);
            });
        });
    }
    calculateLatLngBounds(stores) {
        const bounds = new woosmap.map.LatLngBounds();
        if (SERVICE_REGISTRY.itinaryService.getOrigin()) {
            const origin = SERVICE_REGISTRY.itinaryService.getOrigin();
            bounds.extend(new woosmap.map.LatLng(origin.lat, origin.lng));
        }
        for (const store of stores) {
            bounds.extend(new woosmap.map.LatLng(store.geometry.coordinates[1], store.geometry.coordinates[0]));
        }
        if (SERVICE_REGISTRY.itinaryService.getDestination()) {
            const dest = SERVICE_REGISTRY.itinaryService.getDestination();
            bounds.extend(new woosmap.map.LatLng(dest.lat, dest.lng));
        }
        return bounds;
    }

    onStoresReset() {
        this.data.setMap(null);
        if (this.storeOverlay.getMap() === null) {
            this.storeOverlay.clearSelection();
            this.storeOverlay.setMap(this.map);
        }
        this.nearbyStores = null;
    }

    onUniqueStoreChange(store) {
        this.storeOverlay.setSelection(store);
        this._panToStore(store);
    }
    onStoreSelectedOnRoute(data) {
        this.selectedStore = data;
        this.mainView.setStoreSelectedFromMap(true);
        this.selectedStore_changed();
    }
}
